import { ComponentType } from 'react'

import { Notification } from '@domain'

import BasketAnalysisFailedNotification from './Templates/BasketAnalysisFailedNotification'
import BasketAnalyzedNotification from './Templates/BasketAnalyzedNotification'

export type NotificationTemplateProps = {
	notification: Notification
	type?: SimpleListItem
	variant?: 'list' | 'toast'
	onAction?: (notification: Notification) => void
	onClose?: () => void
	onToggleRead?: (notification: Notification) => void
	'data-testid'?: string
}

export const NOTIFICATION_TEMPLATES: Record<string, ComponentType<NotificationTemplateProps>> = {
	MARKET_BASKET_ANALYZED: BasketAnalyzedNotification,
	BASKET_ANALYSIS_FAILED: BasketAnalysisFailedNotification,
}
